import axios, { AxiosResponse } from 'axios';
import baseUrls from '../urls/urls';
import { logTiming, logError } from './browserRequest';

/**
 * Axios Instance
 */
const ApiClient = axios.create({
    baseURL: baseUrls.icafileUrl,
    headers: {
        'content-type': 'application/json',
        'accept': 'application/json; charset=utf-8'
    }
});

const logRequestSuccess = (startTime: number, response: any, isAuthenticated?: boolean): void => {
    logTiming(startTime, response, isAuthenticated ? 'Authenticated ICA File' : 'Unauthenticated ICA File');
};

interface IrequestParams {
    isAuthenticated?: boolean;
    token?: string;
    username?: string;
    password?: string;
    passcode?: string;
    requestToken?: boolean;
    isMobile?: boolean;
    redirectionUrl?: string;
    hasSharedPassword?: boolean;
    disableReputation?: boolean;
    reputationToken?: string;
    browserId?: string;
    receiverVersion?: string;
    fastLaunch?: boolean;
}


const requestIcafile = (customerId: string, appName: string, requestParams: IrequestParams): Promise<AxiosResponse> => {
    const startTime = Date.now();
    return ApiClient.post(`/${customerId}/${appName}/icafile`, requestParams)
        .then(response => {
            logRequestSuccess(startTime, response, requestParams.isAuthenticated);
            return response;
        }, logError);
};

const requestIcafileTicket = (customerId: string, appName: string, requestParams: IrequestParams): Promise<AxiosResponse> => {
    const startTime = Date.now();
    return ApiClient.post(`/${customerId}/${appName}/icafileurl`, requestParams)
        .then(response => {
            logRequestSuccess(startTime, response, requestParams.isAuthenticated);
            return response;
        }, logError);
};

export {
    requestIcafile,
    requestIcafileTicket
};
